import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { usePaymentMethod } from '@mopla/business-logic';
import { EMlpIconTypes, EMplVariantTypes, MplIconMessage } from '@mopla/ui';

import { isSepaLikePaymentMethod } from './utils';

interface IPaymentMethodRestrictionNoticeProps {
	isSepaRestricted: boolean;
}

/**
 * Orange notice shown for tickets that cannot be paid via SEPA or Pay by Bank
 * (see isSepaRestrictedTicket). A saved default that already works for the
 * ticket makes the notice pointless, so it is suppressed then; with no saved
 * default it still shows, as guidance before the user picks one (MC-12048).
 */
export const PaymentMethodRestrictionNotice: FC<
	IPaymentMethodRestrictionNoticeProps
> = ({ isSepaRestricted }) => {
	const { t } = useTranslation('ticketshop');
	const { defaultPaymentMethod } = usePaymentMethod();

	const hasUsableDefault =
		!!defaultPaymentMethod &&
		!isSepaLikePaymentMethod(defaultPaymentMethod.type);

	if (!isSepaRestricted || hasUsableDefault) {
		return null;
	}

	return (
		<MplIconMessage
			type={EMlpIconTypes.Warning}
			variant={EMplVariantTypes.Warning}
			message={t('payment.sepa_pay_by_bank_unavailable')}
			dataTestid="PaymentMethodRestrictionNotice-MplIconMessage-text"
		/>
	);
};
